// A set's permalink is /sets/<slug>; every other path is the set list.
export function setPath(slug: string): string {
  return `/sets/${encodeURIComponent(slug)}`;
}

export function slugOf(path: string): string | null {
  const m = /^\/sets\/([^/]+)\/?$/.exec(path);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]!);
  } catch {
    return null;
  }
}
